import "core-js/modules/es6.regexp.match";
import _typeof from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.replace";
/**
   * 过滤XSS
   * @param {string}
   * str
   * @return {}
   */
export function filterXSS(str) {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
}

/**
 * 列表数据按max切割出来
 * @param list
 * @param max
 * @returns {*}
 */
export function sliceList(list, max) {
  if (list.length > max) {
    return list.slice(0, max);
  } else {
    return list;
  }
}

/**
 * 同时只执行一次函数，直到前一个promise返回
 * @param func
 * @returns {Function}
 */
export function executeOneInTime(func) {
  var isRunning = false;
  return function () {
    if (!isRunning) {
      isRunning = true;
      var res = func.apply(this, arguments);
      if (_typeof(res) === 'object' && res instanceof Promise) {
        res.then(function () {
          isRunning = false;
        }, function () {
          isRunning = false;
        });
      }
    }
  };
}

/**
 * 防抖函数
 * @param {Function} fn 回调函数
 * @param {Number} wait 等待时间
 */
export function debounce(fn, wait) {
  var timeout = null;
  return function () {
    if (timeout !== null) clearTimeout(timeout);
    timeout = setTimeout(fn, wait);
  };
}
/**
 * 编译expression成function
 * @param {String} tpl 解析模板
 * @param {Function} fn 编译的解析函数
 */
export function compileTpl(tpl) {
  var re = /\$\{([^}]+)?\}/g;
  var reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g;
  var code = 'with(data){ var r=[];\n';
  var cursor = 0;
  var match;
  var add = function add(line, js) {
    js ? code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n' : code += line !== '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '';
    return add;
  };
  while (match = re.exec(tpl)) {
    add(tpl.slice(cursor, match.index))(match[1], true);
    cursor = match.index + match[0].length;
  }
  add(tpl.substr(cursor, tpl.length - cursor));
  code += 'return r.join("");};';
  // eslint-disable-next-line
  return new Function('data', code.replace(/[\r\t\n]/g, ''));
}